<template>
  <div>
    <h4>Extra mezők</h4>
    <el-form
      ref="extraFieldForm"
      :model="extraFieldValues"
      label-position="top"
    >
      <div
        style="display: flex; justify-content: space-between; flex-wrap: wrap"
      >
        <el-form-item
          v-for="field in fields"
          :key="field.id"
          :prop="field.name.replace(/[^A-zÀ-ú0-9 \-]/g, '')"
          :label="field.name"
          style="width: calc(1/2*100% - (1 - 1/2)*20px)"
          :rules="field.is_required ? { required: true, message: 'Mező megadása kötelező', trigger: 'change' } : {}"
        >
          <el-date-picker
            v-if="field.type === 'date'"
            v-model="extraFieldValues[field.name.replace(/[^A-zÀ-ú0-9 \-]/g, '')]"
            type="date"
            style="width: 100%;"
            clearable
            format="yyyy. MM. dd."
            value-format="yyyy-MM-dd"
            :picker-options="{ firstDayOfWeek: 1 }"
            @input="datePickerKey++"
          />
          <el-input
            v-if="field.type === 'text'"
            v-model="extraFieldValues[field.name.replace(/[^A-zÀ-ú0-9 \-]/g, '')]"
          />
          <el-input
            v-if="field.type === 'number'"
            v-model="extraFieldValues[field.name.replace(/[^A-zÀ-ú0-9 \-]/g, '')]"
            type="number"
          />
          <el-select
            v-if="field.type === 'currency'"
            v-model="extraFieldValues[field.name.replace(/[^A-zÀ-ú0-9 \-]/g, '')]"
            style="width: 100%"
            filterable
            clearable
          >
            <el-option
              v-for="currency in currencies"
              :key="currency.code"
              :label="`${currency.code} - ${currency.currency}`"
              :value="currency.code"
            />
          </el-select>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
  const currencies = require('currency-codes/data');
  export default {
    props: ['documentTypeFields', 'docketExtraFieldValues'],
    data() {
      return {
        fields: [],
        extraFieldValues: {},
        datePickerKey: 0,
        currencies
      }
    },

    watch: {
      documentTypeFields(newVal) {
        this.fields = newVal;
      },
      docketExtraFieldValues(newVal) {
        this.extraFieldValues = newVal;
      }
    },

    mounted() {
      this.fields = this.documentTypeFields;
      this.extraFieldValues = this.docketExtraFieldValues;
    }
  }
</script>
